export default __webpack_public_path__ + "static/media/jqc.97decaaf.png";